<template>
    <v-container fill-height>
        <v-layout align-center justify-center row pa-5>
            <v-flex xs12 sm10 md6 text-center>
                <v-icon color="green darken-2" class="mt-12" style="font-size: 10em">mdi-check</v-icon>
                <h1 class="my-12">บันทึกเสร็จสิ้น</h1>
                <h2 class="my-5"><b>เลขที่อ้างอิง : {{ items[0].SU_CODE.replace('_','-') }}</b></h2>
                <v-btn class="mt-5" x-large outlined rounded color="green darken-2" @click="goto('waiting-parcel')">
                    กลับหน้าแรก
                </v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import EventBus from '@/EventBus'

    export default {
        name: "SaveSuccess",
        data() {
            return {
                items: this.getLocalItem().parcelSaveData
            }
        },
        mounted() {
            window.scrollTo(0, 0)
            EventBus.$emit('set_navigation', {title: 'บันทึกรับพัสดุ'});

            let localItem = this.getLocalItem();
            delete localItem.dataSelect;
            delete localItem.logisticName;
            delete localItem.parcelTypeName;
            delete localItem.imageUrl;
            delete localItem.barcode;

            localStorage.setItem('parcel', JSON.stringify(localItem))
        },
        methods: {
            goto(route_name) {
                return this.$router.push({name: route_name})
            }
        }
    }
</script>

<style scoped>

</style>